import { faker } from '@faker-js/faker';
import dayjs from 'dayjs';
import { defaultsDeep } from 'lodash';

import { MaoCrew } from '#entities';

import { generateAirport } from './locationFixtures';

import type { CrewMember, MaoCrewDuty } from '#entities';
import type { DeepPartial } from '#shared';

export const generateCrewMember = (): CrewMember => {
  const onDutyDateTime =
    new Date().getTime() - faker.number.int({ min: 0, max: 14 * 60 }) * 60000;
  return {
    firstNames: `${faker.person.firstName()} ${faker.person.firstName()}`,
    lastName: faker.person.lastName(),
    onDutyDateTime: new Date(onDutyDateTime).toISOString(),
    onDutyDateTimeUnix: onDutyDateTime,
    offDutyDateTime: new Date(onDutyDateTime + 14 * 60 * 60000).toISOString(),
    offDutyDateTimeUnix: onDutyDateTime + 14 * 60 * 60000,
    id: faker.number.int({ min: 1 }),
  };
};

export const generateCrewDuty = (
  overrides: DeepPartial<MaoCrewDuty> = {
    AircraftId: faker.number.int({ min: 1 }),
  },
): MaoCrewDuty => {
  const onDutyDateTime = dayjs().subtract(
    faker.number.int({ min: 0, max: 14 * 60 }),
    'minutes',
  );

  const crew: MaoCrew = {
    Contact: {
      FirstNames: `${faker.person.firstName()} ${faker.person.firstName()}`,
      LastName: faker.person.lastName(),
    },
    Id: faker.number.int({ min: 1 }),
  };
  return defaultsDeep(
    {
      EndAirport: generateAirport(),
      StartAirport: generateAirport(),
      OnDutyDateTime: onDutyDateTime.toISOString(),
      OffDutyDateTime: onDutyDateTime.add(14, 'hours').toISOString(),
      Crew: crew,
      Id: faker.number.int({ min: 1 }),
    },
    overrides,
  );
};
